import { getItem, setItem } from '../utils/localStorage';
import { assessments as assessmentApi } from '../components/Dashboard/apiCaller';

const findHotelWithSubscription = (hotels) => {
  const selectedHotel = hotels.find(
    (hotel) => hotel.myLqaSubscriptionPurchased
  );

  return selectedHotel
    ? {
        hotelId: selectedHotel.id,
        brandId: selectedHotel.brandId,
        clientId: selectedHotel.clientId,
      }
    : null;
};

export function handleBrandAndHotelData (brands) {
  const allHotels = brands.flatMap((brand) => brand.hotels);
  let selectedBrandId;
  let selectedClientId;

  let selectedHotelId = getItem('selectedHotel');
  if (selectedHotelId) {
    const selectedHotel = allHotels.find(
      (hotel) =>
        hotel.id === selectedHotelId &&
        hotel.clientId === getItem('selectedClient')
    );
    if (selectedHotel) {
      selectedBrandId = selectedHotel.brandId;
      selectedClientId = selectedHotel.clientId;
    }
  }

  if (!selectedBrandId || !selectedHotelId) {
    const hotelWithSubscription = findHotelWithSubscription(allHotels);
    if (hotelWithSubscription) {
      selectedBrandId = hotelWithSubscription.brandId;
      selectedHotelId = hotelWithSubscription.hotelId;
      selectedClientId = hotelWithSubscription.clientId;
    } else {
      selectedBrandId = brands[0].id;
      selectedHotelId = brands[0].hotels[0].id;
      selectedClientId = brands[0].hotels[0].clientId;
    }
  }

  setItem('selectedBrand', selectedBrandId);
  setItem('selectedHotel', selectedHotelId);
  setItem('selectedClient', selectedClientId);
  setItem('allHotels', allHotels);
}

export function getBrandAndHotelData () {
  if (getItem('allHotels')) {
    return getItem('allHotels');
  }
  const userData = getItem('user');
  if (
    userData &&
    userData.user &&
    userData.user.brands &&
    userData.user.brands.length
  ) {
    handleBrandAndHotelData(userData.user.brands);
    return userData.user.brands.flatMap((brand) => brand.hotels);
  }
}

export async function hasAssessmentCheck () {
  try {
    const response = await assessmentApi();
    const hasAssessment = response.length > 0;
    await setItem('hasAssessment', hasAssessment);
    return hasAssessment;
  } catch (error) {
    console.error('Error fetching assessment:', error);
    return false;
  }
}

export function gethasAssessment () {
  let hasAssessment = getItem('hasAssessment');
  if (hasAssessment === null || hasAssessment === undefined) {
    hasAssessment = hasAssessmentCheck();
  }
  return hasAssessment;
}

export const userHotelDetails = () => {
  const userData = getItem('user');
  const selectedHotel = getItem('selectedHotel');
  const selectedBrand = getItem('selectedBrand');
  const selectedClient = getItem('selectedClient');
  const allHotels = getItem('allHotels');
  return { userData, selectedHotel, selectedBrand, selectedClient, allHotels };
};
